<template>
  <div class="base-authentication page">
    <navigation :customClickEvent="true" @click="detentionVisible=true">天美贷</navigation>
    <authBanner />
    <!-- 标题 -->
    <section class="title">
      <h1>
        <span>工作信息</span>
      </h1>

    </section>

    <!-- 表单 -->
    <form ref="form" class="form">
      <div class="card-panel">
        <div class="form-item underline-un-focus">
          <nd-choose name="salaries" v-model="form.salaries" :data="dictionary.salaries" :valueKey="['key', 'description']" label="月收入">
          </nd-choose>
        </div>
        <div class="form-item underline-un-focus">
          <nd-choose name="occupations" v-model="form.occupations" :data="occupations" :valueKey="['key', 'description']" label="职业" @change="occupationChange" @scroll="occupationScroll" @open="openOccupation" @close="closeOccupation">
          </nd-choose>
        </div>

        <!-- 满足条件的选项展示单位信息填写 -->
        <div v-show="computedCondition">
          <div class="form-item underline-un-focus">
            <nd-input name="corpName" v-model="form.corpName" label="单位名称" placeholder="请输入四位以上的单位名称" text-align="right" maxLength="40" @blur="corpNameBlur" @focus="corpNameFocus" @input="corpNameInput">
            </nd-input>
          </div>
        </div>
      </div>

      <div class="card-title">
        <img src="./images/base_2.png">
        <span>联系人1</span>
      </div>

      <div class="card-panel">
        <div class="form-item underline-un-focus">
          <nd-choose name="relation1" v-model="form.relation1" :data="dictionary.relationship1" :valueKey="['key', 'description']" label="亲属">
          </nd-choose>
        </div>

        <div class="form-item underline-un-focus">
          <nd-input name="name1" v-model="form.name1" maxLength="10" label="姓名" placeholder="请填写姓名" text-align="right">
          </nd-input>
        </div>

        <div class="form-item underline-un-focus">
          <nd-input name="mobile1" v-model="form.mobile1" maxLength="11" placeholder="请填写手机号" label="手机号" type="pure-number" text-align="right">
          </nd-input>
        </div>
      </div>

      <div class="card-title">
        <img src="./images/base_3.png">
        <span>联系人2</span>
      </div>

      <div class="card-panel">
        <div class="form-item underline-un-focus">
          <nd-choose name="relation2" v-model="form.relation2" :data="dictionary.relationship2" :valueKey="['key', 'description']" label="朋友">
          </nd-choose>
        </div>

        <div class="form-item underline-un-focus">
          <nd-input name="name2" v-model="form.name2" maxLength="10" label="姓名" placeholder="请填写姓名" text-align="right">
          </nd-input>
        </div>

        <div class="form-item underline-un-focus">
          <nd-input name="mobile2" v-model="form.mobile2" maxLength="11" type="pure-number" placeholder="请填写手机号" label="手机号" text-align="right">
          </nd-input>
        </div>
      </div>
    </form>

    <nd-button class="submit-btn" :disabled="isDisabled" @click="submitBaseInfo">提交资料，立获额度</nd-button>

    <div class="protocol-container">
      <p>点击「提交资料，立获额度」按钮即表示您已阅读并同意</p>
      <a href="javascript:;" @click="viewProtocol">《用户信息授权协议》</a>
    </div>

    <detention v-model="detentionVisible"></detention>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import validate from '@/components/nd-validate'
import { judgeClientSystem, isEmptyObject, isEmojiCharacter } from '../../assets/utils'

export default {
  name: 'base-authentication',

  mixins: [validate],

  data () {
    return {
      form: {
        salaries: '',
        occupations: '',
        corpName: '',
        corpPhone: '',
        relation1: '',
        name1: '',
        mobile1: '',
        relation2: '',
        name2: '',
        mobile2: ''
      },
      isDisabled: true,
      detentionVisible: false,
      activityVisible: false,
      rules: {
        salaries: [
          {
            require: true, message: '月收入不能为空', trigger: 'change'
          }
        ],
        occupations: [
          {
            require: true, message: '职业不能为空', trigger: 'change'
          }
        ],
        corpName: [
          {
            require: false, message: '单位名称不能为空', trigger: 'blur'
          },
          {
            handler: input => input.length > 4 && /[\u4e00-\u9fa5]/.test(input[0]) && !isEmojiCharacter(input),
            message: '请输入正确的单位名称',
            trigger: 'blur'
          }
        ],
        relation1: [
          {
            require: true, message: '请选择和联系人的关系', trigger: 'change'
          }
        ],
        name1: [
          {
            require: true, message: '联系人姓名不能为空', trigger: 'blur'
          }, {
            handler: input => !isEmojiCharacter(input),
            message: '姓名中不能带有表情',
            trigger: 'blur'
          },
          {
            handler: input => /^[a-zA-Z]{2,10}$|^[\u4E00-\u9FA5]{2,10}$/g.test(input),
            message: '请输入2-10位的中/英文',
            trigger: 'blur'
          }
        ],
        mobile1: [
          {
            require: true, message: '联系人手机号不能为空', trigger: 'blur'
          }, {
            regular: /^1(?:3\d|4[5-9]|5[0-35-9]|6[6]|7[2-8]|8\d|9[0-35-9])\d{8}$/,
            message: '联系人手机号格式不正确',
            trigger: 'blur',
            error: (mobile) => {
              if (mobile) {
                this.contactErrorEventOccurCount++
              }
            }
          }, {
            handler: (val) => {
              if (val === this.userInfo.mobile) return false
              return true
            },
            message: '本人不能为联系人，请重新输入',
            trigger: 'blur',
            error: (mobile) => {
              if (mobile) {
                this.contactErrorEventOccurCount++
              }
            }
          }, {
            handler: (val) => {
              if (val === this.form.mobile2 && /^1(?:3\d|4[5-9]|5[0-35-9]|6[6]|7[2-8]|8\d|9[0-35-9])\d{8}$/.test(this.form.mobile2)) return false
              return true
            },
            message: '联系人重复，请重新输入',
            trigger: 'blur',
            error: (mobile) => {
              if (mobile) {
                this.contactErrorEventOccurCount++
              }
            }
          }
        ],
        relation2: [
          {
            require: true, message: '请选择和联系人的关系', trigger: 'change'
          }
        ],
        name2: [
          {
            require: true, message: '联系人姓名不能为空', trigger: 'blur'
          }, {
            handler: input => !isEmojiCharacter(input),
            message: '姓名中不能带有表情',
            trigger: 'blur'
          },
          {
            handler: input => /^[a-zA-Z]{2,10}$|^[\u4E00-\u9FA5]{2,10}$/g.test(input),
            message: '请输入2-10位的中/英文',
            trigger: 'blur'
          }
        ],
        mobile2: [
          {
            require: true, message: '联系人手机号不能为空', trigger: 'blur'
          }, {
            regular: /^1(?:3\d|4[5-9]|5[0-35-9]|6[6]|7[2-8]|8\d|9[0-35-9])\d{8}$/,
            message: '联系人手机号格式不正确',
            trigger: 'blur',
            error: (mobile) => {
              if (mobile) {
                this.contactErrorEventOccurCount++
              }
            }
          }, {
            handler: (val) => {
              if (val === this.userInfo.mobile) return false
              return true
            },
            message: '本人不能为联系人，请重新输入',
            trigger: 'blur',
            error: (mobile) => {
              if (mobile) {
                this.contactErrorEventOccurCount++
              }
            }
          }, {
            handler: (val) => {
              if (val === this.form.mobile1 && /^1(?:3\d|4[5-9]|5[0-35-9]|6[6]|7[2-8]|8\d|9[0-35-9])\d{8}$/.test(this.form.mobile1)) return false
              return true
            },
            message: '联系人重复，请重新输入',
            trigger: 'blur',
            error: (mobile) => {
              if (mobile) {
                this.contactErrorEventOccurCount++
              }
            }
          }
        ]
      },

      // 切换网页发生次数
      blurEventOccurCount: 0,
      // 陀螺仪旋转发生次数
      deviceorientationEventOccurCount: 0,
      // 联系人电话校验不通过次数
      contactErrorEventOccurCount: 0,
      // 上次粘贴的内容
      clipboardText: '',
      agreeProtocol: true,
      pfrom: this.$route.query.pfrom,
      giveUpReason: [
        '我再逛逛',
        '放弃免费额度'
      ],
      deviceIp: '',
      currentOccupationData: {},
      winHeight: '',
      popupList: [],
      activityTempleVisible: false,
      currentActivity: {}
    }
  },
  components: {
    authBanner: () => import('./components/authBanner.vue'),
    detention: () => import('./components/detention.vue')
  },
  computed: {
    ...mapState({
      dictionary: state => state.dictionary || {},
      caseList: state => state.caseList
    }),

    ...mapState('user', [
      'userInfo'
    ]),

    ...mapState('authentication', [
      'baseInfo'
    ]),
    occupations () {
      if (!this.dictionary.occupations) {
        return []
      }
      if (!['H', 'G', 'A'].includes(this.form.occupations)) {
        return this.dictionary.occupations.filter(i => {
          return !['H', 'G', 'A'].includes(i.key)
        })
      } else {
        return this.dictionary.occupations
      }
    },
    computedCondition () {
      return this.form.occupations && !['H', 'G', 'A'].includes(this.form.occupations)
    },
    popConfirmTitle () {
      return this.currentActivity.activeType === 'NEW_PERSON_V2' ? '马上拿钱' : '继续完成实名认证'
    },
    popCancelTitle () {
      return this.currentActivity.activeType === 'NEW_PERSON_V2' ? '放弃好运' : (this.currentActivity.activeType === 'NEW_PERSON' ? '放弃奖励' : '放弃免息返现')
    }
  },

  beforeRouteLeave (to, from, next) {
    this.checkInputStep()
    this.cacheBaseInfo(this.form)
    next()
  },

  async created () {
    window.history.pushState({}, '', window.location.href)
    window.addEventListener('popstate', () => {
      this.detentionVisible = true
    })
    
    try {
      await Promise.all([this.fetchDictionaryX(), this.getUserInfo()])
      this.$bus.$emit('ready')
      if (this.form.salaries) {
        this.$nextTick(() => {
          this.validate(this.$refs.form, this.rules)
        })
      }
      this.initDataEvent()
    } catch (exp) {
      this.$bus.$emit('error')
    }
  },

  destroyed () {
    // 离开时移除监听事件
    this.destoryDataEvent()
  },

  methods: {
    ...mapActions([
      'fetchDictionaryX',
      'getCaseListX'
    ]),

    ...mapActions('authentication', [
      'saveBaseInfoX',
      'creditApplyX',
      'getBaseInfoX'
    ]),

    ...mapMutations('authentication', [
      'cacheBaseInfo'
    ]),

    ...mapActions('user', [
      'getUserInfoX'
    ]),

    // 检查用户填写到哪一步了
    checkInputStep () {
      const step1 = this.validateWithoutTip({
        education: this.rules.education,
        marital: this.rules.marital,
        // societyPosition: this.rules.societyPosition,
        salaries: this.rules.salaries,
        occupations: this.rules.occupations,
        corpName: this.rules.corpName,
        addressSelect: this.rules.addressSelect,
        address: this.rules.address
      })
      if (!step1) {
        this.$report({
          id: 10079,
          args: {
            step: 0
          }
        })
        return
      }
      const step2 = this.validateWithoutTip({
        relation1: this.rules.relation1,
        name1: this.rules.name1,
        mobile1: this.rules.mobile1
      })
      if (!step2) {
        this.$report({
          id: 10079,
          args: {
            step: 1
          }
        })
        return
      }
      const step3 = this.validateWithoutTip({
        relation2: this.rules.relation2,
        name2: this.rules.name2,
        mobile2: this.rules.mobile2
      })
      if (!step3) {
        this.$report({
          id: 10079,
          args: {
            step: 2
          }
        })
        return
      }
      return this.$report({
        id: 10079,
        args: {
          step: 3
        }
      })
    },

    // 获取字典
    initDictionary () {
      this.fetchDictionaryX()
    },

    // 获取用户信息
    async getUserInfo () {
      await this.getUserInfoX({ forceUpdate: true, queryType: 'detail' })
      let baseInfo = {}

      // 先取后端返回的用户信息
      let userDetail = this.userInfo.userDetail
      const contacts = this.userInfo.contacts
      if (userDetail && !isEmptyObject(userDetail)) {
        let contactInfo = null
        if (contacts && contacts.length > 0) {
          contactInfo = {
            name1: contacts[0] && contacts[0].contactName,
            relation1: contacts[0] && contacts[0].relation,
            mobile1: contacts[0].mobileNumber,
            name2: contacts[1] && contacts[1].contactName,
            relation2: contacts[1] && contacts[1].relation,
            mobile2: contacts[1] && contacts[1].mobileNumber
          }
        }

        userDetail = {
          address: userDetail.address,
          corpName: userDetail.corpName,
          education: userDetail.education,
          marital: userDetail.marital,
          occupations: userDetail.occupations,
          salaries: userDetail.salaries
          // societyPosition: userDetail.societyPosition,
        }
        // 当只有有地址时，才赋值地址
        if (userDetail.province && userDetail.city && userDetail.area && userDetail.provinceCode && userDetail.cityCode && userDetail.areaCode) {
          userDetail.addressSelect = `${userDetail.province} ${userDetail.city} ${userDetail.area} ${userDetail.provinceCode} ${userDetail.cityCode} ${userDetail.areaCode}`
        }
        if (contactInfo) {
          Object.assign(baseInfo, contactInfo, userDetail)
        } else {
          Object.assign(baseInfo, userDetail)
        }
      } else {
        // 再看本地缓存的
        await this.getBaseInfoX()
        if (!isEmptyObject(this.baseInfo)) {
          Object.assign(baseInfo, this.baseInfo)
        }
      }
      // 回填
      if (!isEmptyObject(baseInfo)) {
        Object.keys(baseInfo).forEach(key => {
          this.$set(this.form, key, baseInfo[key])
        })
      }
    },

    // 提交资料
    async submitBaseInfo () {
      this.$report({
        id: 10080
      })
      const submitInfo = {
        salaries: this.form.salaries,
        occupations: this.form.occupations,
        corpName: this.form.corpName,
        contactList: [
          {
            name: this.form.name1,
            relation: this.form.relation1,
            mobile: this.form.mobile1
          }, {
            name: this.form.name2,
            relation: this.form.relation2,
            mobile: this.form.mobile2
          }
        ]
      }

      // 缓存用户基本信息
      this.cacheBaseInfo(this.form)

      const response = await this.saveBaseInfoX(submitInfo).catch(() => this.$indicator.close())
      if (response.success) {
        // 全部完成 -> 去授信
        this.$statistics('BASE_SUC')
        await this.riskReport(2)
        const creditResponse = await this.creditApplyX({
          creditFLowType: 'H5_CREDIT',
          loanPlatform: 'TMD'
        })
        if (creditResponse.success) {
          this.$statistics('CREDIT_SUB_SUC')
          this.$report({
            id: 10133,
            args: {
              succeed: 1
            }
          })
          // 如果排队，跳排队页面
          if (creditResponse.data.needQueue) {
            return this.$router.replace(`/authentication/wait?applyNo=${creditResponse.data.applyNo}`)
          }
          this.$router.replace(`/landing/h5-credit-result`)
        } else {
          this.$report({
            id: 10133,
            args: {
              succeed: 0,
              message: creditResponse.msg
            }
          })
          this.$statistics('CREDIT_SUB_FAIL', {
            comment: creditResponse.msg
          })
          this.$message(creditResponse.msg)
        }
      } else {
        this.$statistics('BASE_FAIL', {
          comment: response.msg
        })
        this.$message(response.msg)
      }
    },

    initDataEvent () {
      window.addEventListener('blur', this.blurEvent)
      window.addEventListener('deviceorientation', this.orientationEvent)
      window.addEventListener('paste', this.pasteEvent)
      const system = judgeClientSystem()
      if (system === 'IOS') {
        document.body.addEventListener('focusin', this.iosFocusIn)
        document.body.addEventListener('focusout', this.iosFocusOut)
      } else {
        this.winHeight = document.documentElement.clientHeight
        window.addEventListener('resize', this.androidWindowResize)
      }
    },

    destoryDataEvent () {
      window.removeEventListener('blur', this.blurEvent)
      window.removeEventListener('deviceorientation', this.orientationEvent)
      window.removeEventListener('paste', this.pasteEvent)
      const system = judgeClientSystem()
      if (system === 'IOS') {
        document.body.removeEventListener('focusin', this.iosFocusIn)
        document.body.removeEventListener('focusout', this.iosFocusOut)
      } else {
        window.removeEventListener('resize', this.androidWindowResize)
      }
    },

    blurEvent () {
      this.blurEventOccurCount++
    },

    pasteEvent (event) {
      try {
        event.clipboardData.items[0].getAsString(str => {
          this.clipboardText = str
        })
      } catch (error) {
      }
    },

    // 查看协议
    viewProtocol () {
      this.$router.push({
        path: '/protocol/authorization',
        query: {
          busiType: 'CREDIT'
        }
      })
    },
 
   

    occupationChange (data) {
      this.currentOccupationData = data
    },

    occupationScroll () {
    },

    maritalChange (data) {
    },

    maritalScroll () {
    },

    addressChange (data) {

    },

    addressScroll () {
    },

    // IOS键盘弹出时会触发focusin事件
    iosFocusIn () {
    },

    // IOS键盘收起时会触发focusout事件
    iosFocusOut () {
    },

    // 安卓手机键盘弹出和收起时多半都会触发resize事件
    androidWindowResize () {
      var thisHeight = document.documentElement.clientHeight
      if (this.winHeight - thisHeight > 100) {
        this.winHeight = thisHeight
      } else if (this.winHeight - thisHeight < -100) {
        this.winHeight = thisHeight
      }
    },

    // 现居住地获得焦点
    addressFocus () {
    },

    // 现居住地失去焦点
    addressBlur () {
    },

    // 现居住地内容发生变化
    addressInput (target) {
    },

    // 单位名称获取焦点
    corpNameFocus () {
    },

    // 单位名称失去焦点
    corpNameBlur () {
    },

    // 单位名称内容发生变化
    corpNameInput (target) {
    },

    // 单位电话获得焦点
    corpPhoneFocus () {
    },

    // 单位电话失去焦点
    corpPhoneBlur () {
    },

    // 单位电话内容发生变化
    corpPhoneInput (target) {
    },

    // 单位地址获得焦点
    corpAddressFocus () {
    },

    // 单位地址失去焦点
    corpAddressBlur () {
    },

    // 单位地址内容发生变化
    corpAddressInput (target) {
    },

    // 选择职业 - 下拉框弹出
    openOccupation () {
    },

    // 选择职业 - 下拉框收起
    closeOccupation () {
    },

    // 选择婚姻状况-下拉框弹出
    openMarital () {
    },

    // 选择婚姻状况-下拉框收起
    closeMarital () {
    },

    // 选择现居住地-下拉框弹出
    openAddress () {
    },

    // 选择现居住地-下拉框收起
    closeAddress () {
    }
  },

  watch: {
    computedCondition: {
      handler (val) {
        this.rules.corpName[0].require = val
      }
    },

    detentionVisible (value) {
      this.$report({
        id: 10082,
        args: {
          visible: value ? 1 : 0
        }
      })
    },

    activityVisible (value) {
      this.$report({
        id: 10121,
        args: {
          position: 'page_auth_baseinfo',
          visible: value ? 1 : 0,
          status: this.currentActivity.activeType
        }
      })
    },

    activityTempleVisible (value) {
      this.$report({
        id: 10121,
        args: {
          position: 'page_auth_identity',
          visible: value ? 1 : 0,
          status: this.currentActivity.activeType
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.page.base-authentication {
  background-color: #F7F7F7;
  padding-bottom: 63px;

  .title {
    margin-top: 30px;
    display: flex;
    align-items: center;
    padding-left: 40px;
    padding-bottom: 20px;
    &:before {
      display: inline-block;
      content: '';
      width: 10px;
      height: 44px;
      background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
      margin-right: 10px;
    }

    h1 {
      font-size: 46px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      height: 65px;
      line-height: 65px;
      color: @fc1;
      position: relative;

      span {
        margin-left: 10px;
      }
    }

    h2 {
      margin-top: 17px;
      font-size: 28px;
      line-height: 40px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: @fc3;
    }
  }

  .form {
    .card-title {
      height: 45px;
      line-height: 45px;
      margin: 75px 40px 23px;
      font-size: 32px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: @fc3;
      position: relative;

      img {
        width: 44px;
        height: 44px;
        position: absolute;
        left: 0;
      }

      span {
        margin-left: 56px;
      }
    }

    .card-panel {
      background-color: white;

      .form-item {
        height: 110px;
        line-height: 110px;
        padding: 0 40px;
        margin-top: 0;

        &.textarea {
          .nd-input {
            margin-top: 40px;
            line-height: 1.4em;
          }
        }

        .nd-select,
        .nd-input,
        .nd-choose,
        .nd-address {
          label {
            font-size: 30px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
          }

          input {
            font-size: 30px;
          }

          textarea {
            font-size: 30px;
          }
        }

        .nd-input {
          .nd-input-inner {
            line-height: 1.4em;
          }
        }
      }
    }
  }

  .submit-btn {
    margin: 0 auto;
    margin-top: 80px;
  }

  .protocol-container {
    color: @fc3;
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    line-height: 33px;
    text-align: center;
    margin-top: 30px;

    a {
      margin-top: 4px;
      color: #8EB2D8;
    }
  }

  .detention-dialog {
    .detention-title {
      margin: 0 58px;
      text-align: center;
      font-size: 36px;
      line-height: 50px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      padding-bottom: 34px;
      border-bottom: 1px solid #EEEEEE;
    }

    .giveup {
      li {
        height: 110px;
        line-height: 110px;
        text-align: center;
        font-size: 30px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: @fc3;
        border-bottom: 1px solid #EEEEEE;
      }
    }

    .continue {
      border: 0px solid transparent;
      height: 160px;
      line-height: 160px;
      text-align: center;
      font-size: 36px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: @theme;
      width: 100%;
      -webkit-appearance: none;
      outline: none;
      background-color: #FFFFFF;
    }
  }

  .activity-dialog {
    .activity-content {
      padding: 0 60px;
      padding-top: 42px;
      padding-bottom: 42px;

      .slogan {
        height: 42px;

        img {
          height: 100%;
          width: unset;
        }
      }

      .text {
        font-size: 32px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: @fc1;
        font-weight: 400;
        margin-top: 43px;


      }

      p {
        em {
          font-style: normal;
          color: @theme;
        }
      }

      .description {
        width: 500px;
        height: 130px;
        background-color: #FFF0F0;
        padding: 29px 0;
        border-radius: 16px;
        margin-top: 100px;
        padding-left: 141px;
        position: relative;

        .desc-image {
          height: 160px;
          width: 116px;
          background-image: url(./images/img_ren@2x.png);
          position: absolute;
          left: 30px;
          bottom: 0px;
          background-size: cover;
        }

        p {
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: @fc2;
          line-height: 1.6em;
        }
      }

      .continue-btn {
        width: 440px;
        margin: 0 auto;
        height: 80px;
        line-height: 80px;
        font-size: 36px;
        font-weight: 600;
        margin-top: 70px;
      }

      .giveup-btn {
        height: 40px;
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        line-height: 40px;
        color: @fc3;
        text-decoration: underline;
        text-align: center;
        margin-top: 22px;
      }
    }

    .activity-template-content {
      width: 620px;
      height: 750px;
      background-size: contain;
      position: relative;

      .button-group {
        position: absolute;
        bottom: 48px;
        left: 50%;
        transform: translateX(-50%);

        .continue-btn {
          width: 440px;
          margin: 0 auto;
          height: 80px;
          line-height: 80px;
          font-size: 36px;
          font-weight: 600;
          margin-top: 70px;
        }

        .giveup-btn {
          height: 40px;
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          line-height: 40px;
          color: @fc3;
          text-decoration: underline;
          text-align: center;
          margin-top: 22px;
        }
      }
    }
  }
}

/deep/.new-person-activity {
  .default-content {
    padding-top: 0;
  }
}
</style>


